/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
  faUser,
  faFilter,
  faWarning,
  faFileExcel,
} from '@fortawesome/free-solid-svg-icons';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import moment from 'moment';
import Swal from 'sweetalert2';
import { isValidIndianPhoneNumber, isValidName } from '../../components/Validators';
import LoadingModal from '../../components/LoadingModal';
import Search from '../../components/Search';
import logoImg from '../../assets/images/logo.png';
import {
  getAllPendingFarmerProfiles,
  getAllCompletedFarmerProfiles,
  getAllRejectedFarmerProfiles,
  searchFarmerProfiles,
  filterFarmerProfiles,
  exportFarmerProfiles,
} from '../../store/modules/newUser/actions';
import {
  selectPendingFarmerProfiles,
  selectCompletedFarmerProfiles,
  selectRejectedFarmerProfiles,
  selectIsLoading,
} from '../../store/modules/newUser/selectors';
import withScreenRefreshDetection from '../../utils/withScreenRefreshDetection';
import './FarmerProfileList.scss';
import ModalFarmerProfileFilter from '../../components/ModalFarmerProfileFilter';

const ListNewFarmerProfiles = ({ isRefreshed }) => {
  const dispatch = useDispatch();
  const role = localStorage.getItem('role');
  const pendingProfiles = useSelector((state) => selectPendingFarmerProfiles(state));
  const completedProfiles = useSelector((state) => selectCompletedFarmerProfiles(state));
  const rejectedProfiles = useSelector((state) => selectRejectedFarmerProfiles(state));
  const isLoading = useSelector((state) => selectIsLoading(state));

  const [tabIndex, setTabIndex] = useState(0);
  const [query, setQuery] = useState(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filters, setFilters] = useState({
    fromDate: null,
    plantCode: null,
    hprCode: null,
    regionName: null,
    toDate: null,
  });

  const filterApplied = localStorage.getItem('isFilterAppliedForFarmerProfiles');

  const values = {
    page: 1,
    limit: 10,
  };

  const fetchDetailsBasedOnStates = () => {
    if (tabIndex === 0) {
      dispatch(getAllPendingFarmerProfiles(values, role));
    } else if (tabIndex === 1) {
      dispatch(getAllCompletedFarmerProfiles(values, role));
    } else if (tabIndex === 2) {
      dispatch(getAllRejectedFarmerProfiles(values, role));
    }
  };

  const handleConfirmRemoveFilter = () => {
    localStorage.removeItem('isFilterAppliedForFarmerProfiles');
    fetchDetailsBasedOnStates();
  };

  useEffect(() => {
    if (filterApplied) {
      Swal.fire({
        icon: 'warning',
        title: 'Filter applied for farmer profiles, do you want to continue anyway?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#f26868',
        confirmButtonText: 'Continue',
        cancelButtonText: 'Remove Filter',
        toast: true,
      }).then((result) => {
        if (result.isDismissed) {
          handleConfirmRemoveFilter();
        }
      });
    } else {
      fetchDetailsBasedOnStates();
    }
  }, [tabIndex]);

  useEffect(() => {
    if (isRefreshed) {
      localStorage.removeItem('isFilterAppliedForFarmerProfiles');
    }
  }, [isRefreshed]);

  const handleChange = (event) => {
    const { value } = event.target;
    setQuery(value);
  };

  const handleOnSearch = async () => {
    let searchValues;

    if (isValidIndianPhoneNumber(query)) {
      searchValues = {
        phone: query,
        page: 1,
        limit: 10,
      };
    } else if (isValidName(query)) {
      searchValues = {
        farmerName: query,
        page: 1,
        limit: 10,
      };
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Search',
        text: 'Please enter a valid phone number or farmer name',
        toast: true,
      });
      return;
    }
    if (tabIndex === 0) {
      dispatch(getAllPendingFarmerProfiles(searchValues, role));
    } else if (tabIndex === 1) {
      dispatch(getAllCompletedFarmerProfiles(searchValues, role));
    } else if (tabIndex === 2) {
      dispatch(getAllRejectedFarmerProfiles(searchValues, role));
    }
    // Note: Search might need to be context-aware (pending/completed/rejected)
    // For now, using the general search which usually searches across everything or needs update.
    // If the API supports status in search, we should pass it.
    // Assuming searchFarmerProfiles handles it or searches globally.
    // dispatch(searchFarmerProfiles(searchValues, role));
  };

  const handleOnFilter = () => {
    setShowFilterModal(!showFilterModal);
  };

  const getStatusByTab = () => {
    if (tabIndex === 0) return 'pending';
    if (tabIndex === 1) return 'approved';
    return 'rejected';
  };

  const handleOnExport = () => {
    const exportValues = {
      ...filters,
      status: getStatusByTab(),
    };

    if (query) {
      if (isValidIndianPhoneNumber(query)) {
        exportValues.phone = query;
      } else if (isValidName(query)) {
        exportValues.farmerName = query;
      }
    }

    dispatch(exportFarmerProfiles(exportValues, role));
  };

  const submitFilter = (e) => {
    const filterValues = {
      page: 1,
      limit: 10,
      fromDate: moment(e.fromDate).format('DD/MM/YYYY'),
      plantCode: e?.plantCode === 'Choose here' ? null : e?.plantCode,
      hprCode: e?.hprCode === 'Choose here' ? null : e?.hprCode,
      regionName: e?.regionName === 'Choose here' ? null : e?.regionName,
      toDate: moment(e.toDate).format('DD/MM/YYYY'),
    };
    setFilters(filterValues);

    // Dispatch specific action based on tab
    if (tabIndex === 0) {
      dispatch(getAllPendingFarmerProfiles(filterValues, role));
    } else if (tabIndex === 1) {
      dispatch(getAllCompletedFarmerProfiles(filterValues, role));
    } else if (tabIndex === 2) {
      dispatch(getAllRejectedFarmerProfiles(filterValues, role));
    }
    localStorage.setItem('isFilterAppliedForFarmerProfiles', true);
  };

  const nextPage = (page) => {
    const nextPageValue = {
      page,
      limit: 10,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      plantCode: filters.plantCode,
      hprCode: filters.hprCode,
      regionName: filters.regionName,
    };
    if (tabIndex === 0) dispatch(getAllPendingFarmerProfiles(nextPageValue, role));
    else if (tabIndex === 1) dispatch(getAllCompletedFarmerProfiles(nextPageValue, role));
    else if (tabIndex === 2) dispatch(getAllRejectedFarmerProfiles(nextPageValue, role));
  };

  const previousPage = (page) => {
    const previousPageValue = {
      page,
      limit: 10,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      plantCode: filters.plantCode,
      hprCode: filters.hprCode,
      regionName: filters.regionName,
    };
    if (tabIndex === 0) dispatch(getAllPendingFarmerProfiles(previousPageValue, role));
    else if (tabIndex === 1) dispatch(getAllCompletedFarmerProfiles(previousPageValue, role));
    else if (tabIndex === 2) dispatch(getAllRejectedFarmerProfiles(previousPageValue, role));
  };

  const handleOnBackPress = () => {
    fetchDetailsBasedOnStates();
  };

  const getDetailRoute = (farmerId) => {
    if (role === 'plant-admin' || role === 'plant_ic') {
      return `/plant-admin/farmer-profile/${farmerId}`;
    }
    return `/admin/farmer-profile/${farmerId}`;
  };

  // Determine which filter fields to show based on role
  const getFilterFields = () => {
    const fields = ['fromDate', 'toDate', 'hprCode'];

    if (role === 'admin') {
      // Admin sees all fields
      return ['fromDate', 'toDate', 'plantCode', 'regionName', 'hprCode'];
    }
    if (role === 'plant-admin' || role === 'plant_ic') {
      // Plant admin doesn't see plantCode
      return ['fromDate', 'toDate', 'regionName', 'hprCode'];
    }
    // Other users don't see plantCode or regionName
    return fields;
  };

  const renderCard = (item) => (
    <div className="col-12 col-lg-12" key={item.id}>
      <div className="card">
        <div className="card__left">
          <div className="card__avatar">
            {item?.profilePicture ? (
              <img src={item?.profilePicture} alt="farmer" />
            ) : (
              <img src={logoImg} alt="user" />
            )}
          </div>
          <div className="row between col-9">
            <div className="card__text">
              <div>
                <span className="card__title">Farmer Name: </span>
                {item?.farmerName || 'N/A'}
              </div>
              <div>
                <span className="card__title">Registration ID: </span>
                {item?.id || 'N/A'}
              </div>
              <div>
                <span className="card__title">Phone: </span>
                {item?.phone || 'N/A'}
              </div>
              <div>
                <span className="card__title">Gender: </span>
                {item?.gender || 'N/A'}
              </div>
              <div>
                <span className="card__title">Village: </span>
                {item?.village || 'N/A'}
              </div>
            </div>
            <div className="card__text">
              <div>
                {/* <span className="card__title">HPR Code: </span> */}
                {item?.farmerType === 'HPC' ? <span className="card__title"> HPC Code: </span> : item?.farmerType === 'MCC' ? <span className="card__title">MCC Code: </span> : <span className="card__title">DF Code: </span>}
                {item?.facilityCode || 'N/A'}
              </div>
              <div>
                <span className="card__title">Farmer Code: </span>
                {item?.farmerCode || 'N/A'}
              </div>
              <div>
                <span className="card__title">Date of Birth: </span>
                {item?.dob ? moment(item?.dob).format('DD/MM/YYYY') : 'N/A'}
              </div>
              <div>
                <span className="card__title">Mandal: </span>
                {item?.mandal || 'N/A'}
              </div>
              <div>
                <span className="card__title">District: </span>
                {item?.district || 'N/A'}
              </div>
            </div>
            <div className="card__text">
              <div>
                <span className="card__title">Created At: </span>
                {moment(item?.createdAt).format('DD/MM/YYYY')}
              </div>
              <div>
                <span className="card__title">Created Time: </span>
                {moment(item?.createdAt).format('hh:mm a')}
              </div>
              {tabIndex === 2 && (
                <div>
                  <span className="card__title">Reason: </span>
                  <span className="card__text--danger">
                    {item?.rejectionReason || 'N/A'}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="card__right">
          <Link
            to={getDetailRoute(item?.id)}
            className="card__button"
          >
            View
          </Link>
        </div>
      </div>
    </div>
  );

  const renderPagination = (data) => (
    <div className="row">
      <div className="col-12 col-lg-12 d-flex-col middle">
        <div className="pagination">
          <button
            type="button"
            className="pagination__btn"
            disabled={!data.Previous}
            onClick={() => previousPage(data.Previous.page)}
          >
            <FontAwesomeIcon
              icon={faChevronLeft}
              className="pagination__btn__icon"
            />
          </button>
          <span className="pagination__page">
            {data.Next
              ? data.Next.page - 1
              : data.Previous
                ? data.Previous.page + 1
                : 1}
          </span>
          <button
            type="button"
            className="pagination__btn"
            disabled={!data.Next}
            onClick={() => nextPage(data.Next.page)}
          >
            <FontAwesomeIcon
              icon={faChevronRight}
              className="pagination__btn__icon"
            />
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="admin-orders">
        {filterApplied && (
          <div className="filterAppliedFlag">
            <FontAwesomeIcon icon={faWarning} style={{ marginRight: 5 }} />
            In order to dynamically remove the filter that has been applied to farmer profiles, please refresh the page.
          </div>
        )}

        <div className="row">
          <div className="col-12">
            <div className="heading" onClick={handleOnBackPress}>
              <p className="heading__title">
                <FontAwesomeIcon icon={faChevronLeft} />
                {' '}
                New Farmer Profiles
              </p>
            </div>
          </div>
        </div>

        <div className="row middle">
          <div className="col-12 col-md-6">
            <Search
              value={query}
              label="Find Farmers By Name or Phone"
              onChangeText={handleChange}
              onSubmit={handleOnSearch}
            />
          </div>
          <div className="col-12 col-md-6">
            <div className="buttons">
              <button
                type="button"
                className="button primary"
                onClick={handleOnFilter}
              >
                <FontAwesomeIcon icon={faFilter} className="button__icon" />
                Filter
              </button>
              <button
                type="button"
                className="button green"
                onClick={handleOnExport}
              >
                <FontAwesomeIcon icon={faFileExcel} className="button__icon" />
                Export
              </button>
            </div>
          </div>
        </div>

        <Tabs
          defaultIndex={0}
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
        >
          <TabList className="row between tab-list">
            <Tab className="col-4 tab">
              <div className={`type-card ${tabIndex === 0 ? 'selected' : ''}`}>
                Waiting for Approval
              </div>
            </Tab>
            <Tab className="col-4 tab">
              <div className={`type-card ${tabIndex === 1 ? 'selected' : ''}`}>
                Completed
              </div>
            </Tab>
            <Tab className="col-4 tab">
              <div className={`type-card ${tabIndex === 2 ? 'selected' : ''}`}>
                Rejected
              </div>
            </Tab>
          </TabList>

          <TabPanel className="appointments-tab-panel">
            <div className="row">
              {pendingProfiles && pendingProfiles.paginate && pendingProfiles.paginate.length
                ? pendingProfiles.paginate.map((item) => renderCard(item))
                : null}
              {!isLoading && (!pendingProfiles || !pendingProfiles.paginate || pendingProfiles.paginate.length === 0) && (
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="notFound">
                    <FontAwesomeIcon
                      icon={faUser}
                      className="notFound__icon"
                    />
                    <span className="notFound__text">
                      No pending farmer profiles found
                    </span>
                  </div>
                </div>
              )}
            </div>
            {pendingProfiles && pendingProfiles.paginate && pendingProfiles.paginate.length > 0
              ? renderPagination(pendingProfiles) : null}
          </TabPanel>

          <TabPanel className="appointments-tab-panel">
            <div className="row">
              {completedProfiles && completedProfiles.paginate && completedProfiles.paginate.length
                ? completedProfiles.paginate.map((item) => renderCard(item))
                : null}
              {!isLoading && (!completedProfiles || !completedProfiles.paginate || completedProfiles.paginate.length === 0) && (
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="notFound">
                    <FontAwesomeIcon
                      icon={faUser}
                      className="notFound__icon"
                    />
                    <span className="notFound__text">
                      No completed farmer profiles found
                    </span>
                  </div>
                </div>
              )}
            </div>
            {completedProfiles && completedProfiles.paginate && completedProfiles.paginate.length > 0
              ? renderPagination(completedProfiles) : null}
          </TabPanel>

          <TabPanel className="appointments-tab-panel">
            <div className="row">
              {rejectedProfiles && rejectedProfiles.paginate && rejectedProfiles.paginate.length
                ? rejectedProfiles.paginate.map((item) => renderCard(item))
                : null}
              {!isLoading && (!rejectedProfiles || !rejectedProfiles.paginate || rejectedProfiles.paginate.length === 0) && (
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="notFound">
                    <FontAwesomeIcon
                      icon={faUser}
                      className="notFound__icon"
                    />
                    <span className="notFound__text">
                      No rejected farmer profiles found
                    </span>
                  </div>
                </div>
              )}
            </div>
            {rejectedProfiles && rejectedProfiles.paginate && rejectedProfiles.paginate.length > 0
              ? renderPagination(rejectedProfiles) : null}
          </TabPanel>
        </Tabs>

        {showFilterModal ? (
          <ModalFarmerProfileFilter
            show={showFilterModal}
            toggle={handleOnFilter}
            onSubmit={submitFilter}
            filterFields={getFilterFields()}
            role={role}
          />
        ) : null}
      </div>
      <LoadingModal show={isLoading} />
    </>
  );
};

export default withScreenRefreshDetection(ListNewFarmerProfiles);
